<template>
  <div
    class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-[200] h-full w-full"
  >
    <div
      class="h-[90vh] w-full sm:w-3/4 bg-white rounded p-5 max-sm:m-3 space-y-5 text-sm overflow-y-auto"
    >
      <div class="flex justify-end">
        <button
          @click="closeDetail()"
          class="flex justify-center items-center bg-blue-200 h-8 w-8 rounded-full text-sm text-white hover:bg-blue-300"
        >
          <font-awesome-icon icon="fa-solid fa-x" />
        </button>
      </div>

      <section class="space-y-4">
        <h2 class="text-xl font-semibold text-center">
          {{ lang === "mn" ? "Уулзалтын дэлгэрэнгүй" : "Meeting Details" }}
        </h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <strong>{{
              lang === "mn" ? "Уулзалтын дугаар:" : "Meeting Number:"
            }}</strong>
            <p>{{ meeting?.meeting_number }}</p>
          </div>
          <div>
            <strong>{{ lang === "mn" ? "Төлөв:" : "Status:" }}</strong>
            <p
              :class="{
                'text-green font-semibold':
                  meeting?.meeting_status === 'accepted',
                'text-red-600 font-semibold':
                  meeting?.meeting_status === 'cancelled',
                'text-yellow-600 font-semibold':
                  meeting?.meeting_status === 'pending',
              }"
            >
              {{
                meeting?.meeting_status === "accepted"
                  ? lang === "mn"
                    ? "Зөвшөөрсөн"
                    : "Accepted"
                  : meeting?.meeting_status === "cancelled"
                  ? lang === "mn"
                    ? "Цуцлагдсан"
                    : "Cancelled"
                  : lang === "mn"
                  ? "Хүлээгдэж байна"
                  : "Pending"
              }}
            </p>
          </div>

          <div>
            <strong>{{ lang === "mn" ? "Илгээгч:" : "Sender:" }}</strong>
            <p>
              {{
                lang === "mn" ? meeting?.sender_name : meeting.sender_name_en
              }}
            </p>
          </div>
          <div>
            <strong>{{ lang === "mn" ? "Хүлээн авагч:" : "Receiver:" }}</strong>
            <p>
              {{
                lang === "mn"
                  ? meeting?.receiver_name
                  : meeting?.receiver_name_en
              }}
            </p>
          </div>
          <div>
            <strong>{{
              lang === "mn" ? "Өрөөний дугаар:" : "Room Number:"
            }}</strong>
            <p>{{ meeting?.room_number }}</p>
          </div>
          <div>
            <strong>{{ lang === "mn" ? "Багтаамж:" : "Capacity:" }}</strong>
            <p>{{ meeting?.capacity }}</p>
          </div>
          <div>
            <strong>{{ lang === "mn" ? "Огноо:" : "Date:" }}</strong>
            <p>{{ new Date(meeting?.meeting_date).toLocaleDateString() }}</p>
          </div>
          <div>
            <strong>{{ lang === "mn" ? "Цаг:" : "Time:" }}</strong>
            <p>{{ meeting?.meeting_time }}</p>
          </div>
          <div v-if="meeting?.meeting_description">
            <strong>{{
              lang === "mn" ? "Уулзалтын зорилго:" : "Purpose of the meeting:"
            }}</strong>
            <p>{{ meeting?.meeting_description }}</p>
          </div>
        </div>

        <div class="w-full mt-4">
          <strong>{{
            lang === "mn" ? "Өрөөний зураг:" : "Room Image:"
          }}</strong>
          <img
            :src="meeting?.room_pic"
            alt="Room Image"
            class="w-full rounded shadow mt-2 max-h-[300px] object-cover"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "YellowMeetingDetail",
  emits: ["closeDetail"],
  props: {
    selectedMeeting: Object,
  },
  setup(props, { emit }) {
    const closeDetail = () => emit("closeDetail");

    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);
    const meeting = ref(null);

    onMounted(() => {
      if (props.selectedMeeting) {
        meeting.value = props.selectedMeeting;
      }
    });

    return {
      lang,
      closeDetail,
      meeting,
    };
  },
};
</script>
